export default __webpack_public_path__ + "static/media/Error.a46ef7e2.png";